import { PropsWithChildren } from 'react';

import './PaperContainer.css'

function PaperContainer({ children }: PropsWithChildren) {
  return (
    <div className="PaperContainer w-full bg-repeat bg-center">
      {children}
    </div>
  );
}

export default PaperContainer;
